import { Glec_Tradelanes } from '@/graphql/types';

import { store } from './store';

export type TradelanesFilter = Glec_Tradelanes & {
  id: string;
  label: string;
  selected: boolean;
  left: string;
  right?: string;
};

// quick hack to parse & group tradelanes easily
const rx =
  /^(Intra )?(?<left>[a-zA-Z\s]+)((\s+to-from\s+)(?<right>[a-zA-Z\s]+))?$/;

// init store
const setTradelanes = (tradelanes: Glec_Tradelanes[]) => {
  store.tradelanes = tradelanes.map((t) => {
    const result = rx.exec(t.tradelane);
    return {
      ...t,
      id: t.tradelane,
      label: t.tradelane,
      selected: false,
      // left will hold the left part of the tradelane (before to-from or after Intra)
      left: result?.groups?.left || t.tradelane,
      // right will hold the right part of the tradelane (after to-from or null if Intra)
      right: result?.groups?.right,
    };
  });
};

const getTradelane = (id: string): TradelanesFilter | null => {
  const tradelane = store.tradelanes.find((t) => t.id === id);
  return tradelane || null;
};

const setSelectedTradelanes = (ids: string[]) => {
  store.tradelanes.forEach((tradelane) => {
    tradelane.selected = ids.includes(tradelane.id);
  });
};

const unselectTradelane = (id: string) => {
  const tradelane = store.tradelanes.find((tradelane) => tradelane.id === id);
  if (tradelane) {
    tradelane.selected = false;
  }
};

const unselectAllTradelanes = () => {
  store.tradelanes.forEach((tradelane) => {
    tradelane.selected = false;
  });
};

const selectTradelanes = (ids: string[]) => {
  ids.map(getTradelane).forEach((tradelane) => {
    if (tradelane) {
      tradelane.selected = true;
    }
  });
};

const unselectTradelanes = (ids: string[]) => {
  ids.map(getTradelane).forEach((tradelane) => {
    if (tradelane) {
      tradelane.selected = false;
    }
  });
};

export {
  setTradelanes,
  setSelectedTradelanes,
  getTradelane,
  unselectTradelane,
  unselectAllTradelanes,
  selectTradelanes,
  unselectTradelanes,
};
